import Button from "../../components/Button";
import WeekPicker from "../../components/WeekPicker";

// - - - - - - - - - -
// Per-grid toolbar (#105 phase 3 / 4c): renders inside each OptimizerGrid
// header. Holds only the controls that should be independent per grid:
//   - Today button
//   - Week-picker (prev / next + date display)
//   - Close X button (top-right; disabled when only one grid is open)
//
// Everything else (location, capacity, filters, Show 'OFF', timestamp,
// polling indicators) lives in the shared <GlobalToolbar> above all grids.

export const PerGridToolbar = ({
  weekDatesArray,
  onWeekToday,
  onWeekBehind,
  onWeekAhead,
  canNavigateWeekBack,
  disabled,
  onClose,
  canClose,
}) => {
  return (
    <section className="flex gap-4 text-sm font-medium items-center">
      {/* spacer left of the centered group, mirrors the close button width */}
      <span className="w-8 shrink-0"></span>
      <div className="flex-1 flex gap-4 items-center justify-center">
        <Button onClick={() => onWeekToday()} disabled={disabled}>
          Today
        </Button>
        <WeekPicker
          disabled={disabled}
          weekBehind={() => onWeekBehind()}
          weekAhead={() => onWeekAhead()}
          value={weekDatesArray[0]}
          disableBack={!canNavigateWeekBack}
        ></WeekPicker>
      </div>
      <button
        onClick={onClose}
        disabled={!canClose}
        title={
          canClose
            ? "Close this grid"
            : "Cannot close — at least one grid must remain open"
        }
        className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-full text-skin-primary text-lg leading-none ${
          canClose
            ? "hover:opacity-100 cursor-pointer opacity-60"
            : "opacity-20 cursor-not-allowed"
        }`}
        style={{ transition: "opacity 150ms" }}
        aria-label="Close grid"
      >
        ✕
      </button>
    </section>
  );
};

export default PerGridToolbar;
